export const getOrdinalSuffix = (value: number) => {
  const normalizedValue = Math.abs(Math.trunc(value));
  const lastTwoDigits = normalizedValue % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return 'th';
  }

  switch (normalizedValue % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatDateWithOrdinalMonthYear = (isoDate: string, locale: string) => {
  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) {
    return isoDate;
  }

  const day = parsed.getDate();
  const month = parsed.toLocaleDateString(locale, { month: 'short' });
  const year = parsed.getFullYear();

  return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
};
